<button
  [type]="type"
  [class]="classes + ' group inline-flex justify-center items-center gap-1'"
  [attr.aria-label]="ariaLabel || text"
  [disabled]="disabled"
  (click)="onClick($event)">
  <span>{{ text }}</span>
  @if (image) {
    <img [src]="image" [alt]="ariaLabel || text" class="inline-block h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
  }
</button>
